<template>

  <StandardMap ref="mapContainer"
               :include-service-areas-layer="false"
               :include-feature-highlight-layer="false"
               :min-width="350"
               :min-height="650"
               class="position-relative red"
  >

    <!--    <l-control position="bottomright">-->
    <!--      <v-card>-->
    <!--        <pre class="overflow-y-auto" style="max-height: 300px !important;">{{selectedAddress}}</pre>-->
    <!--      </v-card>-->
    <!--    </l-control>-->


    <l-control position="topleft">
      <v-toolbar
        floating
        width="600"
        style="z-index: 8001 !important;"
      >
        <h3 class="title">{{pageTitle}}</h3>
        <h6 class="subtitle-1 ml-3 blue-grey--text">By address or by clicking the map.</h6>
      </v-toolbar>
    </l-control>

    <l-control position="topleft">
      <AddressSearch @address-selected="handleAddressSelected"></AddressSearch>
    </l-control>

  </StandardMap>

</template>

<script>
import { LatLng } from 'leaflet';
import StandardMap from '../components/map-components/StandardMap';
import AddressSearch from '../components/AddressSearch';

export default {

  name: 'SearchForService',

  components: { AddressSearch, StandardMap, },

  data() {
    return {
      pageTitle: 'Search For Service',
      query: '',
      selectedAddress: null,
    };
  },

  mounted() {
    this.$store.commit('SET_IDENTIFY_POINT', null);
  },

  watch: {

    query(query) {
      this.addressQuery(query);
    },

  },

  computed: {},

  methods: {

    handleAddressSelected(address) {
      if (address) {
        this.selectedAddress = address;
        const location = address.location;
        const latlng = new LatLng(location.y, location.x);
        this.$store.dispatch('identifyPoint', { latlng });
        this.$refs.mapContainer.setViewSpecified(latlng);
      }
    },

  },

};
</script>

<style lang="scss">

  #addressSearchSATable.v-data-table th, #addressSearchSATable.v-data-table td {
    font-size: 8pt;
    height: 24px;
  }

</style>
